// src/types/Rma.ts

export interface Rma {
  ticketId: string;
  ticketCreationDatetime: string;
  ticketClosureDatetime: string;
  rmaStartDatetime: string;
  rmaCloseDatetime: string;
  networkId: string | number | undefined;
  siteId: string | number | undefined;
  linkId: string | number | undefined;
  assetId: string | number | undefined;
  teamId: string | number | undefined;
  personId: string | number | undefined;
  communicationWithCustomer: string;
  userid: any;
  ticketCreation: string;
  ticketClosure: string;
  summary: string;
  rmaStart: string;
  rmaClose: string;
  email: string;
  customername: string;
  asset: string;
  affectedCustomer: string[];
  affectedNetwork: string[];
  affectedSite: string[];
  affectedLink: string[];
  errorType: string;
  closureCode: string;
  createdby: string;
  impact: string;
  urgency: string;
  priority: string;
  responsibleTeam: string;
  responsiblePerson: string;
  customerComplaint: boolean;
  customerInformed: boolean;
  status: string;
  journalUpdate: string;
  communication: string;
  sla: string;
  slaStatus: string;
  reactionPoint: string;
  responseTimeToOpen: string;
  responseTimeToClose: string;
  acceptanceTime: string;
  ola: string;
  olaStatus: string;
  acceptanceStatus: string;
  foruserid: number[];
  filePath: File[] | null;
  uploadPath: string;
  relatedobject: string[];
  customer: string;
  pointofcontact: string;
  brand: string;
  model: string;
  partnumber: string;
  serialnumber: string;
  password: string;
  faultdescription: string;
  activewarranty: string;
  zip: string;
  country: string;
  region: string;
  city: string;
  address1: string;
  address2: string;
  phonenumber: string;
  name: string;
  companyname: string;
  forno: string;
  vendorrmacross: string;
  ior: string;
  tracklocation: string;
  trackstage: string;
  solution: string;
}

export const initialRma: Rma = {
  ticketId: "",
  userid: "",
  ticketCreation: "",
  ticketClosure: "",
  rmaStart: "",
  rmaClose: "",
  affectedCustomer: [],
  affectedNetwork: [],
  affectedSite: [],
  affectedLink: [],
  trackstage: "",
  asset: "",
  summary: "",
  errorType: "",
  createdby: "",
  customername: "",
  closureCode: "",
  impact: "",
  urgency: "",
  priority: "",
  responsibleTeam: "",
  responsiblePerson: "",
  customerComplaint: false,
  customerInformed: false,
  email: "",
  status: "",
  journalUpdate: "",
  communication: "",
  sla: "",
  slaStatus: "",
  reactionPoint: "",
  responseTimeToOpen: "",
  responseTimeToClose: "",
  acceptanceTime: "",
  ola: "",
  olaStatus: "",
  ticketCreationDatetime: "",
  ticketClosureDatetime: "",
  rmaStartDatetime: "",
  rmaCloseDatetime: "",
  networkId: undefined,
  siteId: undefined,
  linkId: undefined,
  assetId: undefined,
  teamId: undefined,
  personId: undefined,
  communicationWithCustomer: "",
  acceptanceStatus: "",
  foruserid: [],
  filePath: [],
  uploadPath: "",
  relatedobject: [],
  customer: "",
  pointofcontact: "",
  brand: " ",
  model: "",
  partnumber: "",
  serialnumber: "",
  password: "",
  faultdescription: "",
  activewarranty: "",
  country: "",
  region: "",
  city: "",
  address1: "",
  address2: "",
  phonenumber: "",
  name: "",
  companyname: "",
  forno: "",
  vendorrmacross: "",
  ior: "",
  zip: "",
  tracklocation: "",
  solution: "",
};
